import tw from "twin.macro";

export const SimpleCardSection = tw.div`rounded-lg m-4 p-4 border border-gray-300 bg-white dark:bg-gray-900 dark:border-gray-800`;
